'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TagsSidebarController', [
	'$scope',
	'$stateParams',
	'TagMain',
	'FullscreenModal',
	'$state',
	function (
		$scope,
		$stateParams,
		TagMain,
		FullscreenModal,
		$state
	) {
		$scope.TagMain = TagMain;
		$scope.dropdownOpen = false;


		/**
		 * Callback to select the new screenshot according to the current
		 * filter selection
		 */
		$scope.filterChanged = function(mainFilterField) {

			// Get the screenshots which match the main filter field
			// (do a strict match so that language "de-at" would only match
			// "de-at")
			var screenshots = TagMain.getScreenshotsFromFilter(mainFilterField, false);

			if (screenshots.length !== 0) {
				TagMain.setScreenshots(screenshots);

				// Add the filter parameters to the url
				var filterParameters = {
					mainFilter: mainFilterField.value
				};
				TagMain.filterFields.forEach(function(filterField) {
					filterParameters[filterField.value] = filterField.selected;
				});
				$state.go('.', filterParameters, {inherit: true, notify: false});
			}

			$scope.dropdownOpen = false;
		};


		/**
		 * Opens the currently active screenshot fullscreen
		 */
		$scope.openFullscreenScreenshot = function() {
			if (TagMain.tag && TagMain.tag.hasOwnProperty('_screenshots') && TagMain.screenshotIndex < TagMain.tag._screenshots.length) {
				TagMain.openFullscreenScreenshot($scope.activeEntry.key);
			}
		};


	}
]);
